import React from "react";
import ProjectSquare from "./MobileProjectSquare";
import images from "../../data/projectImages.js"

const MobileProgress = () => {
  return (
    <div className="flex flex-col justify-center items-center p-8 pt-0">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 place-items-center justify-center gap-y-6 w-full p-2">
        <ProjectSquare
          imageUrl={images["FenwayCenterP2"][0]}
          name="Fenway Center Phase II"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["380Stuart"][0]}
          name="380 Stuart Street"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["88Seaport"][0]}
          name="88 Seaport"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["BackBay"][0]}
          name="Back Bay Tower"
          loc="Boston, MA"
        />
        <ProjectSquare
          imageUrl={images["MassGeneralP2"][0]}
          name="Mass General Brigham Hospital Phase 2"
          loc="Boston, MA"
        />
      </div>
    </div>
  );
};

export default MobileProgress;